import { GeographicalRegion, getInitGeographicalRegion } from "./geographical-region.model";

export interface SubGeographicalRegion {
    id: number | null;
    name: string;
    code: string;
    geographicalRegion: GeographicalRegion
    number: string | null;
    utilityId: number;
}

export function getInitSubGeographicalRegion(): SubGeographicalRegion {
    return {
        id: null,
        name: '',
        code: '',
        geographicalRegion: getInitGeographicalRegion(),
        number: '',
        utilityId: 0,
    };
}

export interface SubGeographicalRegionDataIn {
    id: number | null;
    name: string;
    geographicalRegionId: number | null
    utilityId: number;
    code: string;
    number: string | null;
}

export function getInitSubGeographicalRegionDataIn(): SubGeographicalRegionDataIn {
    return {
        id: null,
        name: '',
        geographicalRegionId: null,
        utilityId: 0,
        code: '',
        number: '',
    };
}